import { SocialEmbed } from '@graphql/index';
import { SocialEmbedProps } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';

const socialEmbedTransform = ({
  socialContent,
}: CleanContentful<SocialEmbed>): SocialEmbedProps => ({
  socialContent,
});

export default socialEmbedTransform;
